import { c as _c } from "react/compiler-runtime";
import HeaderBlock from 'modules/profile/user-plan/components/price-plan-columns/components/header-block';
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum';
import { tableFeatures, UserPlanInterface, UseUserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface';
import { getFeatureLimitTitle } from 'modules/profile/user-plan/utils/price-plan-utils';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export interface UserPlanColumnProps {
  pricePlan: UserPlanInterface;
  billingPeriod: BillingPeriodEnum;
  isOneClickUpgradeAvailable: boolean;
  paymentMethod: UseUserPlanInterface['customer']['paymentMethod'];
  isPlanUpgradeAvailable: boolean;
}
const UserPlanColumn = t0 => {
  const $ = _c(12);
  const {
    pricePlan,
    billingPeriod,
    isOneClickUpgradeAvailable,
    paymentMethod,
    isPlanUpgradeAvailable
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== billingPeriod || $[1] !== isOneClickUpgradeAvailable || $[2] !== isPlanUpgradeAvailable || $[3] !== paymentMethod || $[4] !== pricePlan) {
    t1 = <HeaderBlock pricePlan={pricePlan} billingPeriod={billingPeriod} isOneClickUpgradeAvailable={isOneClickUpgradeAvailable} paymentMethod={paymentMethod} isPlanUpgradeAvailable={isPlanUpgradeAvailable} />;
    $[0] = billingPeriod;
    $[1] = isOneClickUpgradeAvailable;
    $[2] = isPlanUpgradeAvailable;
    $[3] = paymentMethod;
    $[4] = pricePlan;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== pricePlan || $[7] !== t) {
    t2 = tableFeatures.map((column, index) => <React.Fragment key={`column-${column.key}`}><div className="text-text-primary truncate text-center text-base">{getFeatureLimitTitle({
          pricePlan,
          key: column.key,
          t
        })}</div>{tableFeatures[index + 1] ? <hr className="border-border-200 -mr-6 border-solid" /> : <div />}</React.Fragment>);
    $[6] = pricePlan;
    $[7] = t;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <div className="desktop:grid flex w-full min-w-full snap-start flex-col gap-2 border border-transparent">{t1}{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default UserPlanColumn;